import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "BancoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "BancoPage",
            ss: ss,
            ajax: {
                "url": ss.indexBanco(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Banco', name: 'Banco', title: 'Banco' },
                { data: 'Cuenta', name: 'Cuenta', title: 'Cuenta' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            bancos: [],
            banco: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newBanco() {
            this.banco = {};
            this.$refs['frm-banco'].show();
        },
        showBanco(id) {
            this.isLoading=true;
            this.ss.showBanco(id).then(
                (result) => {
                    let response = result.data;
                    this.banco = response.data;
                    this.$refs['view-banco'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editBanco() {
            this.$refs['frm-banco'].show();
            this.$refs['view-banco'].hide();
        },
        cancelBanco() {
            if (this.banco.id) {
                this.$refs['view-banco'].show();
            }
            this.$refs['frm-banco'].hide();
        },
        saveBanco() {
            this.ss.storeBanco(this.banco).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-banco'].hide();
                    this.$refs['datatable-banco'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteBanco() {
            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "¿Esta acción es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyBanco(this.banco)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-banco'].hide();
                                this.$refs['datatable-banco'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Banco').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showBanco(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
